

function ArrowBarDown() {
    return (
      <>
        <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="icon icon-tabler-arrow-bar-to-down"
>
  {/* bar (stays in place) */}
  <path d="M4 20h16" />

  {/* arrow (moves down on hover) */}
  <g className="transition-transform duration-300 group-hover:translate-y-1">
    <path d="M12 14V4" />
    <path d="M12 14l4-4" />
    <path d="M12 14l-4-4" />
  </g>
</svg>
      </>
    )
  }
  
  export default ArrowBarDown;